export const DEVICE_UID_COOKIE_KEY = 'ms_device_uid'
export const USER_AUTH_COOKIE_KEY = 'ms_auth_token'
export const GUEST_PARTY_AUTH_COOKIE_KEY = 'ms_guest_event_auth_token'
export const CONSENT_COOKIE_NAME = 'ms_user_consent'

export const EMAIL_REMINDER_STORAGE_NAME = 'redirectedFromEmailReminder'
